import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import logo from './logo-looktacom.png'; // Vérifie bien le chemin vers ton logo
import './Header.css';

const Header = () => {
    const navigate = useNavigate();

    // On récupère les infos du localStorage
    const isAdmin = localStorage.getItem("isAdmin") === "true";
    const userName = localStorage.getItem("userName");

    // Si l'utilisateur n'est pas connecté, on n'affiche pas le header (ex: page de login)
    if (!isAdmin) return null;

    const handleLogout = async () => {
        try {
            // Appel au back pour détruire la session PHP
            await fetch("https://suivis.looktacom.fr/api/logout.php", { credentials: "include" });
        } catch (err) {
            console.error("Erreur déconnexion serveur", err);
        } finally {
            // Nettoyage local quoi qu'il arrive
            localStorage.clear();
            navigate("/login");
        }
    };

    return (
        <header className="main-header">
            <div className="header-left">
                <img src={logo} alt="Lookta'com" className="h-logo" />
            </div>

            <nav className="header-center">
                <NavLink
                    to="/notes"
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                >
                    Notes
                </NavLink>

            </nav>

            <div className="header-right">
            
                <span className="user-welcome">Bonjour, <strong>{userName}</strong></span>
                <button onClick={handleLogout} className="btn-logout">
                    Déconnexion
                </button>
            </div>
        </header>
    );
};

export default Header;